import { axiosInstance } from ".";

export const registerSeller = async (token, user) => {
  try {
    const result = await axiosInstance.post("admin/create/seller", user);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const createStore = async (token, values) => {
  try {
    const result = await axiosInstance.post("admin/create/brand", values);

    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const createProduct = async (values, token) => {
  try {
    const result = await axiosInstance.post("admin/create/listing", values);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getAllListings = async (token) => {
  try {
    const result = await axiosInstance.get("admin/all/listing");
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const getNewListings = async (token) => {
  try {
    const result = await axiosInstance.get("admin/new/listing");
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const getAdminStats = async (token) => {
  try {
    const result = await axiosInstance.get("admin/dashboard/figure");
    return result.data.data;
  } catch (error) {
    return error.response.data;
  }
};
export const getAdminPendingInfo = async (token) => {
  try {
    const result = await axiosInstance.get("admin/pending/approval");
    return result.data.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getBanks = async (token) => {
  try {
    const result = await axiosInstance.get("admin/brand/get/banks/NG");
    return result.data.data;
  } catch (error) {
    return error.response.data;
  }
};
export const getBrands = async (token) => {
  try {
    const result = await axiosInstance.get("admin/all/brands");
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const getPendingBrands = async (token) => {
  try {
    const result = await axiosInstance.get("admin/pending/brands");
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const getActivatedBrands = async (token) => {
  try {
    const result = await axiosInstance.get("admin/unpublished/brands");
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const getBlockedBrands = async (token) => {
  try {
    const result = await axiosInstance.get("admin/blocked/brands");
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const togglePublishState = async (token, id) => {
  try {
    const result = await axiosInstance.post(
      `admin/toggle/publish/${id}`,
      {}
    );
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const getPage = async (token, url) => {
  try {
    const result = await axiosInstance.get(`${url}`);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getCategories = async (token) => {
  const result = await axiosInstance.get("categories");
  return result.data.data;
};
export const getBrandsPaginated = async (token, page) => {
  const result = await axiosInstance.get(`admin/brands?page=${page}`);
  return result.data;
};

export const getBrand = async (token, sellerId) => {
  const result = await axiosInstance.get(`admin/brand/${sellerId} `);
  return result.data.data;
};
export const getBrandDetails = async (token, sellerId) => {
  const result = await axiosInstance.get(`admin/store/details/${sellerId} `);
  return result.data.data;
};

export const getBrandDetailsAndInformation = async (token, sellerId) => {
  const result = await axiosInstance.get(`admin/store/get/brand/details/${sellerId}`);
  return result.data.data;
};

export const getBrandStats = async (token, sellerId) => {
  const result = await axiosInstance.get(`admin/seller/dashboard/count/${sellerId} `);
  return result.data.data;
};
export const getBrandListings = async (token, sellerId, page) => {
  try {
    const result = await axiosInstance.get(
      `admin/all/listing/${sellerId}?page=${page}`
    );
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getBrandPayment = async (token, sellerId) => {
  const result = await axiosInstance.get(`admin/payment/details/${sellerId} `);
  return result.data.data;
};
export const getBrandBankInfo = async (token, sellerId) => {
  try {
    const result = await axiosInstance.get(`admin/bank/details/${sellerId} `);
    return result.data.data;
  } catch (error) {
    return error.response.data;
  }
};
export const getApprovedProducts = async (token, brandId) => {
  const result = await axiosInstance.get(`admin/brand/approved/products/${brandId}`);
  return result.data;
};
export const getBrandProducts = async (token, brandId) => {
  const result = await axiosInstance.get(`admin/brand/all/products/${brandId}`);
  return result.data;
};
export const getNewProducts = async (token, brandId) => {
  const result = await axiosInstance.get(`admin/brand/new/products/${brandId} `);
  return result.data;
};
export const getProduct = async (token, productId) => {
  try {
    const result = await axiosInstance.get(`admin/brand/listing/${productId}`);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const getBrandDeliveryOption = async (token, sellerId) => {
  try {
    const result = await axiosInstance.get(`admin/view/brand/delivery/${sellerId}`);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const getBrandReturnsOption = async (token, sellerId) => {
  try {
    const result = await axiosInstance.get(`admin/view/brand/returns/${sellerId}`);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const getBrandVacationMode = async (token, sellerId) => {
  try {
    const result = await axiosInstance.get(`admin/view/brand/vacation/${sellerId}`);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const getBrandSizeGuide = async (token, sellerId) => {
  try {
    const result = await axiosInstance.get(`admin/view/brand/sizeguide/${sellerId}`);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const resetBrandPassword = async (token, sellerId) => {
  try {
    const result = await axiosInstance.post(
      `admin/reset/seller/password/${sellerId} `,
      {}
    );
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const updateBrands = async (values, token) => {
  try {
    const result = await axiosInstance.post("admin/edit/brand", values);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const updateBrandDelivery = async (values, token) => {
  try {
    const result = await axiosInstance.post("admin/edit/brand/delivery", values);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const updateBrandReturns = async (values, token) => {
  try {
    const result = await axiosInstance.post("admin/edit/brand/returns", values);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const activateVacationMode = async (token, values) => {
  try {
    const result = await axiosInstance.post("admin/activate/vacation", values);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const deactivateVacationMode = async (token, sellerId) => {
  try {
    const result = await axiosInstance.post(
      `admin/deactivate/vacation/${sellerId}`,
      {}
    );
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const updateBrandSecurity = async (id, values, token) => {
  try {
    const result = await axiosInstance.post(
      `admin/seller/update/password/${id}`,
      values
    );
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const updateBrandDetails = async (id, values, token) => {
  const result = await axiosInstance.post(`admin/seller/update/store/${id}`, values);
  return result.data;
};
export const updateBrandAccount = async (id, values, token) => {
  try {
    const result = await axiosInstance.post(
      `admin/seller/update/details/${id}`,
      values
    );
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const searchBrand = async (token, value) => {
  const result = await axiosInstance.post("admin/brand/search", value);
  return result.data;
};
export const activateBrand = async (token, { brandId, publish }) => {
  try {
    const result = await axiosInstance.post(
      `admin/activate/brand/${brandId}`,
      { publish }
    );
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const deactivateBrand = async (token, storeId) => {
  try {
    const result = await axiosInstance.post(`admin/deactivate/brand/${storeId}`, "");
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const blockBrand = async (token, values) => {
  try {
    const result = await axiosInstance.post(
      `admin/block/seller/${values.sellerId}`,
      { reason: values.reason }
    );
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const unblockBrand = async (token, sellerId) => {
  try {
    const result = await axiosInstance.post(`admin/activate/seller/${sellerId}`, "");
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const approveProduct = async (token, id) => {
  try {
    const result = await axiosInstance.post(`admin/approve/listing/${id}`, "");
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const rejectProduct = async (token, id, reason) => {
  try {
    const result = await axiosInstance.post(
      `admin/reject/listing/${id}`,
      { reason }
    );
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const activateProduct = async (token, id) => {
  try {
    const result = await axiosInstance.post(`admin/product/activate/${id}}`, "");
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const deactivateProduct = async (token, id) => {
  try {
    const result = await axiosInstance.post(`admin/product/deactivate/${id}`, "");
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const deleteProduct = async (token, productId) => {
  try {
    const result = await axiosInstance.post(
      `admin/product/delete/${productId}`,
      { product_id: productId }
    );
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const fetchBanks = async (token) => {
  try {
    const result = await axiosInstance.get("admin/brand/get/banks/NG");
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const updateProduct = async (token, values) => {
  try {
    const result = await axiosInstance.post(`admin/update/product`, values);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const uploadSizeGuide = async (token, values) => {
  try {
    const result = await axiosInstance.post(`/admin/edit/brand/sizeguide`, values);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const deleteSizeGuide = async (token, sellerId) => {
  try {
    const result = await axiosInstance.post(
      `admin/delete/brand/sizeguide/${sellerId}`,
      {}
    );
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const addVariant = async (token, values) => {
  try {
    const result = await axiosInstance.post(`admin/add/variant`, values);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const updateVariant = async (token, values) => {
  try {
    const result = await axiosInstance.post(`admin/update/variant`, values);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const deleteVariant = async (token, variant_id, product_id) => {
  try {
    const result = await axiosInstance.post(
      `admin/delete/variant`,
      { variant_id, product_id }
    );
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const updateQuantity = async (token, values) => {
  try {
    const result = await axiosInstance.post(`admin/update/listing/variety`, values);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const swapImage = async (token, data) => {
  try {
    const result = await axiosInstance.post(`admin/product/image/swap`, data);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
export const deleteImage = async (token, data) => {
  try {
    const result = await axiosInstance.post(`admin/product/image/delete`, data);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const fetchBrandApplications = async (type, token) => {
  try {
    const result = await axiosInstance.get(`application/${type}/list`);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const fetchBrandApplicationDetails = async (token, id) => {
  try {
    const result = await axiosInstance.get(`application/${id}`);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const admimApproveBrand = async (token, data) => {
  try {
    const result = await axiosInstance.post(`application/approve`, data);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const updateNewSellerInfoApi = async (token, values) => {
  try {
    const result = await axiosInstance.post(`update/application`, values);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const bookPhotoshoot = async (token, values) => {
  try {
    const result = await axiosInstance.post(`admin/photoshoot/book/date`, values);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getPhotoshootBookings = async (token) => {
  try {
    const result = await axiosInstance.get(`admin/photoshoots`);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getPhotoshootDetails = async (token, id) => {
  try {
    const result = await axiosInstance.get(`/admin/photoshoots/${id} `);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
